import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-introduction',
  templateUrl: './introduction.component.html',
})
export class IntroductionComponent  extends ReportShareComponent {}
